import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
export const cycleSlug = cycle => {
  var _cycle$cycleDuration, _cycle$cycleDuration2;
  const count = ((_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.count) ?? 1;
  const unit = (_cycle$cycleDuration2 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration2.unit;
  if (unit === PurchaseOffering.DurationUnit.MONTH && count === 1) {
    return 'monthly';
  }
  if (unit === PurchaseOffering.DurationUnit.YEAR && count === 1) {
    return 'yearly';
  }
  return `${count}year`;
};
export const getHigherCycleCopyKeys = targetCycle => {
  const slug = cycleSlug(targetCycle);
  return {
    titleKey: `checkout.summary.${slug}_upsell.benefits.title`,
    ctaKey: `checkout.summary.${slug}_upsell.switch_cycle.cta`
  };
};
export const getLowerCycleCtaKey = (currentCycle, lowerCycle) => `checkout.summary.${cycleSlug(currentCycle)}_upsell.switch_${cycleSlug(lowerCycle)}_cycle.cta`;
//# sourceMappingURL=upsellCopyKeys.js.map